import React from 'react';
import Button from './Button';
import { Link } from 'react-router-dom';

const Footer = () => {
return (
<footer className="container mx-auto text-white">
<div className="py-[60px] px-4">
<div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-x-[150px] gap-y-[60px]'>
<div className='flex flex-col gap-10 items-start'>
<Link to="/">
<img src="/logo.svg" alt="IQONO" />
</Link>
<p className='text-[rgba(255,255,255,0.6)] text-lg leading-[1.1]'>
ONBOARD ONCE. TRANSACT EVERYWHERE.
</p>
<Button variant='primary'>Get Started</Button>
</div>
<div className='flex flex-col gap-5'>
<p className='uppercase text-white text-base leading-[1.1]'>Solutions</p>
<Link to="/products/card-acquiring" className='flex flex-col text-[rgba(255,255,255,0.8)] text-sm leading-[1.1]'>
Card Acquiring
</Link>
<Link to="/products/payouts" className='flex flex-col text-[rgba(255,255,255,0.8)] text-sm leading-[1.1]'>
Global Payouts
</Link>
<Link to="/products/apms" className='flex flex-col text-[rgba(255,255,255,0.8)] text-sm leading-[1.1]'>
Alternative Payment Methods
</Link>
<Link to="/products/open-banking" className='flex flex-col text-[rgba(255,255,255,0.8)] text-sm leading-[1.1]'>
Open Banking
</Link>
<Link to="/products/payment-gateway" className='flex flex-col text-[rgba(255,255,255,0.8)] text-sm leading-[1.1]'>
Payment Gateway
</Link>
          </div>
              <div className='flex flex-col gap-5'>
            <p className='uppercase text-white text-base leading-[1.1]'>Grow With Us</p>
            <Link to="/partners/referral" className='flex flex-col text-[rgba(255,255,255,0.8)] text-sm leading-[1.1]'>
              Rev-Share Program
            </Link>
            <Link to="/partners/join" className='flex flex-col text-[rgba(255,255,255,0.8)] text-sm leading-[1.1]'>
              Partnerships
            </Link>
</div>
<div className='flex flex-col justify-between'>
<div className='flex flex-col gap-5'>
<p className='uppercase text-white text-base leading-[1.1]'>Inside iQono</p>
<Link to="/company/about" className='flex flex-col text-[rgba(255,255,255,0.8)] text-sm leading-[1.1]'>
About Us
</Link>
<Link to="/company/blog" className='flex flex-col text-[rgba(255,255,255,0.8)] text-sm leading-[1.1]'>
Blog
</Link>
<a href="https://developer.iqono.com/" target="_blank" rel="noopener noreferrer" className='flex flex-col text-[rgba(255,255,255,0.8)] text-sm leading-[1.1]'>
Developers
</a>
</div>
<div className='flex gap-5 mt-[60px]'>
{/* <a href='#'>
               <div className='w-10 h-10 bg-[#423ADC1A] border border-[#423ADC0D] rounded-xl flex items-center justify-center'>
                 <img src='/github.png' className='w-5 h-5' />
               </div>
             </a>
             <a href='#'>
               <div className='w-10 h-10 bg-[#423ADC1A] border border-[#423ADC0D] rounded-xl flex items-center justify-center'>
                 <img src='/x.png' className='w-5 h-5' />
               </div>
             </a> */}
<a href='https://www.linkedin.com/company/iqono'>
<div className='w-10 h-10 bg-[#423ADC1A] border border-[#423ADC0D] rounded-xl flex items-center justify-center'>
<img src='/in.png' className='w-5 h-5' alt=''/>
</div>
</a>
</div>
</div>
</div>
<div className="my-8 border-t border-gray-700 flex flex-col md:flex-row justify-between" />
<div className='flex gap-6'>
<p className='flex flex-col text-[rgba(255,255,255,0.8)] text-sm leading-[1.5]'>
{new Date().getFullYear()} iQono — All Rights Reserved
</p>
<Link to="/terms-and-conditions" className="text-purple-400 hover:text-purple-300">Terms & Conditions</Link>
<Link to="/cookie-policy" className="text-purple-400 hover:text-purple-300">Cookies Policy</Link>
<Link to="/privacy-policy" className="text-purple-400 hover:text-purple-300">Privacy Policy</Link>
</div>
</div>
</footer>
);
};

export default Footer;
